exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ExportModal-module__top___NJ480{display:grid;gap:.5rem;margin-bottom:1.5rem}.ExportModal-module__top___NJ480 p{font-size:14px}.ExportModal-module__checkboxes___1Aq2P{display:grid;gap:.5rem;margin-bottom:3rem}.ExportModal-module__checkboxes___1Aq2P .ExportModal-module__check___2isbR{margin-left:.5rem}.ExportModal-module__checkboxes___1Aq2P .ExportModal-module__check___2isbR.ExportModal-module__checked___1E_o9{font-weight:700}.ExportModal-module__button-wrapper___2VyRB{display:flex;justify-content:flex-end;gap:.75rem;grid-auto-flow:column;margin-top:1rem}@media screen and (min-width:1325px){.ExportModal-module__button-wrapper___2VyRB{grid-template-columns:1fr 1fr}}", ""]);

// exports
exports.locals = {
	"top": "ExportModal-module__top___NJ480",
	"checkboxes": "ExportModal-module__checkboxes___1Aq2P",
	"check": "ExportModal-module__check___2isbR",
	"checked": "ExportModal-module__checked___1E_o9",
	"button-wrapper": "ExportModal-module__button-wrapper___2VyRB"
};